import React, { useContext, useEffect, useState } from 'react'
import ButtonBlackReturn from '../../components/Buttons/ButtonBlackReturn'
import AccessBuildings from '../../components/AccessBuildings/AccessBuildings'
import { CustomAlert } from '../../components/CustomAlert/CustomAlert'
import { getCurrentItems, getDataUserByKey, getTenantInfoByKey, getUserBuilding, havePermission } from '../../helpers/helpers'
import { t } from 'i18next'
import CustomPagination from '../../components/CustomPagination/CustomPagination'
import AccessBuildingContext from '../../context/AccessBuildingContext/AccessBuildingContext'
import { Spinner } from 'reactstrap'
import { useNavigate } from 'react-router-dom'
import { EmptyStateOne } from '../../components/Empty/EmptyStateOne'
import { logout } from '../../services/login'

const SelectAccessBuildings = () => {

    const { getAccessBuildings, accessBuildingState, setAccessBuilding, setAccessBuildingSearchable } = useContext(AccessBuildingContext);
    const { accessBuildings, accessBuildingsSearchable, isFetching, error, message } = accessBuildingState;

    const navigate = useNavigate();

    const openingCode = getDataUserByKey('accessOpening').codigo;

    const openingCodeValue = openingCode ? [openingCode] : [];

    const haveSelectAnBuilding = getUserBuilding();

    const canMakeAccess = havePermission(1);

    const [page, setPage] = useState(1);

    const itemsPerPage = 5

    const currentAccessBuildings = getCurrentItems(accessBuildingsSearchable, page, itemsPerPage);

    const noResults = currentAccessBuildings.length === 0;

    const totalPages = Math.ceil(accessBuildingsSearchable.length / itemsPerPage);

    const searchBuildings = (textValue) => {
        setPage(1)
        const newData = accessBuildings.filter(accessBuilding => accessBuilding.buildingDescription.toLowerCase().includes(textValue.toLowerCase()))
        setAccessBuildingSearchable(newData)
    }

    const handleSelectBuilding = (building) => {
        setAccessBuilding(building);
        navigate('/dashboard');
    }

    useEffect(() => {
        if (haveSelectAnBuilding) navigate('/dashboard');
        if (canMakeAccess) getAccessBuildings(false, openingCodeValue)
        else handleSelectBuilding({
            "buildingId": "",
            "buildingCode": "",
            "buildingDescription": t('NO_BUILDING'),
            "opening": null
        });
        // eslint-disable-next-line
    }, [openingCode])

    const backToChooseOpening = () => {
        const userData = JSON.parse(localStorage.getItem('userData')) || {};
        if (userData?.accessOpening?.codigo) {
            delete userData?.accessOpening;
            localStorage.setItem('userData', JSON.stringify(userData));
            return navigate('/selectAccessOpening')
        }
        return logout();
    }

    return (
        <div className={`pe-4 ps-4 pb-5 d-flex flex-column justify-content-between h-100`}>
            {isFetching === true && (
                <div className="d-flex justify-content-center">
                    <Spinner />
                </div>
            )}
            {isFetching === false && (
                <>
                    <div>
                        <ButtonBlackReturn
                            onClick={backToChooseOpening}
                            title={`${t('CHOOSE_BUILD')} ${getTenantInfoByKey('building_name')}`}
                        />
                        <div className='mt-4 mb-2'>
                            <input
                                placeholder={t('SEARCH')}
                                type={"text"}
                                name={'searchOpennings'}
                                className="form-control access-input"
                                autoComplete='off'
                                // value={filterValue}
                                onChange={(e) => searchBuildings(e.target.value)}
                            />
                        </div>
                        <div className='mt-3'>
                            {error && (<CustomAlert color={'danger'} text={message} />)}
                            {noResults && (
                                <EmptyStateOne
                                    message={t('NO_DATA')}
                                />
                            )}
                            <AccessBuildings
                                accessBuildings={currentAccessBuildings}
                                selectBuilding={handleSelectBuilding}
                            />
                        </div>
                    </div>
                    <div className='d-flex justify-content-center'>
                        <CustomPagination
                            totalPages={totalPages}
                            page={page}
                            setPage={setPage}
                        />
                    </div>
                </>
            )}
        </div>
    )
}

export default SelectAccessBuildings